/*
 *  Cart Template
 *    Scripts for Cart template
 *
 *  Version:
 *    2.0.0 - 2019/01/24
 */

/*** Sections ***/


/*** Template ***/
import $ from 'jquery';
import Cookies from 'js-cookie';
import { Accordion } from './../objects/accordion/Accordion';
import { CartQuantitySelector } from './../objects/cart/CartQuantitySelector';
import { CartPromoMessage, SPEND_SAVE_TITLE_SELECTOR } from './../objects/cart/CartPromoMessage';
import { generatePricing } from './../objects/pricing/ProductPricing';
import { InitialzeSVGImages } from './../objects/icon/Icon';
import {
  ON_CART_PENDING, ON_CART_FINISHED, removeFromCart, getCurrentCart, escapeString, printMoney
} from '@process-creative/slate-theme-tools';
import { fetchGeo, onGeoFetch, addInternationalMsgClass } from './../tools/Geo';
import { CartCrossSellLineItems, CROSS_SELL_SELECTOR } from './../objects/cart/CartCrossSellLineItems';
import { drawGift, freeGiftIsPending } from '../sections/gift/FreeGift';


export const CART_TEMPLATE_SELECTOR = '[data-cart-template]';
export const CART_TEMPLATE_INNER = '[data-cart-template-container]';
export const CART_TEMPLATE_PRODUCTS = '[data-cart-template-products]';
export const CART_TEMPLATE_PRODUCT = '[data-cart-template-product]';
export const CART_TEMPLATE_PRODUCT_MAX = '[data-max]';
export const CART_TEMPLATE_REMOVE = '[data-cart-template-remove]';
export const CART_TEMPLATE_SUBTOTAL = '[data-cart-template-subtotal]';
export const CART_TEMPLATE_SUBTOTAL_COMPARE = '[data-cart-template-subtotal-compare]';
export const CART_TEMPLATE_SUBTOTAL_DISCOUNT = '[data-cart-template-subtotal-discount]';
export const CART_TEMPLATE_SUBTOTAL_SNS_MESSAGE = '[data-cart-template-subtotal-spendnsave-message]';
export const CART_TEMPLATE_AFTERPAY = '[data-afterpay-price]';
export const CART_TEMPLATE_CHECKOUT = '[data-cart-body-checkout]';

export const CART_TEMPLATE_COUNTER = '[data-cart-counter]';
export const CART_TEMPLATE_BODY = '[data-cart-page-body]';
// export const CART_TEMPLATE_LINE_PRICE_TOTAL = '[data-cart-line-total]';

export const CART_TEMPLATE_HAS_ITEMS = '[data-cart-template-has-items]';
export const CART_TEMPLATE_NO_ITEMS = '[data-cart-template-no-items]';

export const CART_UPSELL_CONTAINER = '[data-cross-sell]';

export const SELECTOR_ACCORDION = '[data-cart-accordion]';

export const CLASS_PENDING = 'is-pending';
export const CLASS_DISABLED = 'is-disabled';
export const CLASS_HIDDEN = 'is-hidden';
export const CLASS_ACTIVE = 'is-active';

class CartTemplate {
  constructor(container) {
    this.container = container;
    this.quantitySelectors = [];

    //Elements
    this.products = container.find(CART_TEMPLATE_PRODUCTS);
    this.cartBody = container.find(CART_TEMPLATE_BODY);

    this.cartHasItems = container.find(CART_TEMPLATE_HAS_ITEMS);
    this.cartNoItems = container.find(CART_TEMPLATE_NO_ITEMS);
    this.cartSubTotal = container.find(CART_TEMPLATE_SUBTOTAL);
    this.cartSubTotalDiscount = container.find(CART_TEMPLATE_SUBTOTAL_DISCOUNT);
    this.cartSubTotalCompare = container.find(CART_TEMPLATE_SUBTOTAL_COMPARE);
    this.cartSubTotalSNSMessage = container.find(CART_TEMPLATE_SUBTOTAL_SNS_MESSAGE);
    this.cartAfterpayFinalPrice = container.find(CART_TEMPLATE_AFTERPAY);
    this.cartCheckout = container.find(CART_TEMPLATE_CHECKOUT);
    this.cartCounter = container.find(CART_TEMPLATE_COUNTER);

    //Events
    this.setupQuantitySelectors();
    this.cartBody.removeClass(CLASS_PENDING);

    // calling accordion function
    this.accordion = new Accordion(this.container.find(SELECTOR_ACCORDION));

    //promo spend and save message
    if ($(document).find(`[${SPEND_SAVE_TITLE_SELECTOR}]`).length) new CartPromoMessage(container);


    //cross sell
    if ($(document).find(CROSS_SELL_SELECTOR).length) {
      new CartCrossSellLineItems($(document).find(CROSS_SELL_SELECTOR));
    }

    $(document).on(ON_CART_PENDING, () => this.onCartPending());
    $(document).on(ON_CART_FINISHED, () => (this.onCartFinished(),this.updateCartCount()));
    $(document).on('click touchend', CART_TEMPLATE_REMOVE, e => this.removeItem(e));

    //look up geo
    let geoCountry = fetchGeo(data => onGeoFetch(data));
    addInternationalMsgClass(geoCountry);

  }

  async fetchCart() {
    let data;
    try {
      data = await new Promise((resolve, reject) => {
        $.ajax({
          url: '/cart',
          data: { view: 'ajax' },
          success: d => resolve(d) ,
          error: (jqXHR,status,error) => reject(error)
        });
      });
    } catch(e) {
      //Error when fetching cart body
      console.error(e);
      return;
    }

    let cart = getCurrentCart();

    let cartContent = '';

    //Do we have items in the cart?
    if(cart.items.length) {
      cartContent = data;

      //Update Classes
      this.cartNoItems.addClass(CLASS_HIDDEN);
      this.cartHasItems.removeClass(CLASS_HIDDEN);
    } else {
      //Update Classes
      this.cartNoItems.removeClass(CLASS_HIDDEN);
      this.cartHasItems.addClass(CLASS_HIDDEN);
    }

    //Update cart contents
    $('[data-cart-page-body]').html(cartContent);

    new Accordion($(SELECTOR_ACCORDION));

    InitialzeSVGImages();

    if ($(document).find(`[${SPEND_SAVE_TITLE_SELECTOR}]`).length) new CartPromoMessage(this.container);
    if ($(document).find(CROSS_SELL_SELECTOR).length) {
      new CartCrossSellLineItems($(document).find(CROSS_SELL_SELECTOR));
    }

    //Update Prices
    if (cart.original_total_price > cart.items_subtotal_price) {
      this.cartSubTotalCompare.addClass(CLASS_ACTIVE);
      this.cartSubTotalCompare.find('.c-cart-body__footer-subtotal-price').html(generatePricing(cart.original_total_price));
    } else if (cart.original_total_price > cart.total_price) {
      this.cartSubTotalCompare.addClass(CLASS_ACTIVE);
      this.cartSubTotalCompare.find('.c-cart-body__footer-subtotal-price').html(generatePricing(cart.original_total_price))
    } else {
      this.cartSubTotalCompare.removeClass(CLASS_ACTIVE);
    }

    if (cart.total_discount > 0) {
      this.cartSubTotalDiscount.addClass(CLASS_ACTIVE);
      this.cartSubTotalDiscount.find('.c-cart-body__footer-subtotal-price').html(`-${generatePricing(cart.total_discount)}`);
      this.cartSubTotalSNSMessage.addClass(CLASS_ACTIVE);
    } else {
      this.cartSubTotalDiscount.removeClass(CLASS_ACTIVE);
      this.cartSubTotalSNSMessage.removeClass(CLASS_ACTIVE);
    }


    this.cartSubTotal.html(`
      ${generatePricing(
        cart.items_subtotal_price > cart.total_price ? 
        cart.total_price: 
        cart.items_subtotal_price,
        null,'')}
    `);

    this.cartAfterpayFinalPrice.attr('data-money', cart.items_subtotal_price);
    this.cartAfterpayFinalPrice.html(printMoney((cart.items_subtotal_price/4)));

    // $(document).trigger('onCartDrawn');
    this.setupQuantitySelectors();
    drawGift();
  }

  onCartPending(){
    this.cartPending = true;

    //Update Classes
    this.cartBody.addClass(CLASS_PENDING);
    this.cartCheckout.addClass(CLASS_DISABLED);

    this.cartCheckout.attr('disabled', 'disabled');
  }

  onCartFinished() {
    this.cartPending = false;
    const onFetched = () => {
      if(this.cartPending) return;
      this.cartBody.removeClass(CLASS_PENDING);
      this.cartCheckout.removeClass(CLASS_DISABLED);
      this.cartCheckout.removeAttr('disabled');
      if (typeof Yotpo !== 'undefined') {
        var api = new Yotpo.API(yotpo);
        api.refreshWidgets();
      }
    }

    this.fetchCart().then(e => {
      onFetched();
    }).catch(e => {
      console.error(e)
    });
  }

  setupQuantitySelectors() {
    //Destroy
    this.quantitySelectors.forEach(e => e.destroy());

    //Now recreate
    this.quantitySelectors = [];

    let products = $(CART_TEMPLATE_PRODUCT);
    products.each((e, i) => {
      let self = $(i);
      let index = self.attr('data-index');
      this.quantitySelectors.push(new CartQuantitySelector(this, index, self));
    });
  }

  removeItem(e) {
    e.preventDefault(), e.stopPropagation();

    let self = $(e.currentTarget);
    let product = self.closest(CART_TEMPLATE_PRODUCT);
    let index = product.attr('data-index');

    //Now remove Item
    removeFromCart(index).catch(console.error);
  }

  updateCartCount() {
    let cart = getCurrentCart();
    if(cart.item_count > 0) this.cartCounter.text('('+cart.item_count+')');
  }
}




/*
 * Easter Promo Popup
 *   Hides/shows the popup
 */
$(document).ready(function() {
  if(!$('[data-popup]').length) return;

  $(document).on('click', '[data-popup-close]', () => {
    $('[data-popup]').removeClass('c-popup--active');
    $('html').css('overflow', 'auto');
    Cookies.set('easter_promo', new Date().getTime());
  });

  setTimeout(() => {
    try {
      let t = Cookies.get('easter_promo');
      if(t) return;
    } catch(e) {
      console.error(e);
      return;
    }
    $('[data-popup]').addClass('c-popup--active');
    $('html').css('overflow', 'hidden');
  }, 500);

  //cart back button
  let current_location = window.location.href;
  let button_url;

  if (current_location.indexOf('/cart') != -1) {
    button_url = (Cookies.get('last_location')) ? Cookies.get('last_location') : window.location.hostname;
  } else {
    // if user is on any other page, store their location in a cookie
    Cookies.set('last_location', current_location);
  }

});

//Initialize
$(document).ready($(CART_TEMPLATE_SELECTOR).each((e,i) => new CartTemplate($(i))));
